import { ApolloClient, InMemoryCache } from '@apollo/client';

export const DEALER_GATEWAY_URL = 'https://dealer-graphql.apps.emea.vwapps.io/';

export const dealerClient = new ApolloClient({
  uri: DEALER_GATEWAY_URL,
  cache: new InMemoryCache(),
});
